module.exports = __webpack_public_path__ + "img/3-4.277ffdc0.svg";